var validate = {};

validate.phone = function (rule, value, callback) {
    let mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/;
    if (!mobile.test(value) || value.length === 0 || $.trim(value).length > 11) {
        callback(new Error('请输入正确的手机号码'));
    } else {
        callback();
    }
};

validate.onlyNum = function (rule, value, callback) {
    let re = /\D/g;
    if (value === "" || re.test(value)) {
        callback(new Error('请输入数字'));
        return;
    }
    callback();
};

export default validate;


// WEBPACK FOOTER //
// ./src/common/js/validate.js